import { useQuery } from "@tanstack/react-query"
import { LoversApi } from "./LoversApi"

export const useUser = () =>
  useQuery({
    queryKey: ["useUser"],
    queryFn: () =>
      LoversApi()
        .self.getSelf()
        .then((res) => res.data),
    staleTime: 1000 * 60 * 60 * 24 * 30
  })

export const useSelfTimeCapsules = () =>
  useQuery({
    queryKey: ["useSelfTimeCapsules"],
    queryFn: () =>
      LoversApi()
        .self.getSelfTimeCapsules()
        .then((res) => res.data),
    staleTime: 1000 * 60 * 60 * 24
  })

export const useSharedTimeCapsules = () =>
  useQuery({
    queryKey: ["useSharedTimeCapsules"],
    queryFn: () =>
      LoversApi()
        .self.listSelfSharedTimeCapsules()
        .then((res) => res.data),
    staleTime: 1000 * 60 * 60 * 24
  })

export const useSharedTimeCapsuleBySlug = (ownerId: string, slug: string) =>
  useQuery({
    queryKey: ["useSharedTimeCapsuleBySlug", slug, ownerId],
    queryFn: () =>
      LoversApi()
        .self.getSharedTimeCapsuleBySlug(slug, { ownerId })
        .then((res) => res.data),
    staleTime: 1000 * 60 * 60 * 24 * 30
  })

export const useTimeCapsuleBySlug = (slug: string) =>
  useQuery({
    queryKey: ["useTimeCapsuleBySlug", slug],
    queryFn: () =>
      LoversApi()
        .self.getTimeCapsuleBySlug(slug)
        .then((res) => res.data),
    staleTime: 1000 * 60 * 60 * 24 * 30
  })

export const useOpenTimeCapsule = (id: string) =>
  useQuery({
    queryKey: ["useOpenTimeCapsule", id],
    queryFn: () =>
      LoversApi()
        .timeCapsule.openTimeCapsule(id)
        .then((res) => res.data),
    staleTime: 1000 * 60 * 60 * 24 * 30
  })

export const useInvites = () =>
  useQuery({
    queryKey: ["useInvites"],
    queryFn: () =>
      LoversApi()
        .self.getSelfInvites()
        .then((res) => res.data)
  })

export const useTimeCapsuleInvites = (timeCapsuleId: string) =>
  useQuery({
    queryKey: ["useTimeCapsuleInvites", timeCapsuleId],
    queryFn: () =>
      LoversApi()
        .timeCapsule.getTimeCapsuleInvitations(timeCapsuleId)
        .then((res) => res.data)
  })

export const useTimeCapsuleMembers = (timeCapsuleId: string) =>
  useQuery({
    queryKey: ["useTimeCapsuleMembers", timeCapsuleId],
    queryFn: () =>
      LoversApi()
        .timeCapsule.getTimeCapsuleMembers(timeCapsuleId)
        .then((res) => res.data),
    staleTime: 1000 * 60 * 5
  })
